import { createTheme, Theme } from '@mui/material/styles';

const appColors = {
  black: '#141414',
  darkGray: '#141414',
  white: '#FFFFFF',
  grey: ['#53565A', '#888B8D', '#A7A8A9', '#C8C9C7', '#E1DFDD'],
  blue: ['#202A44', '#1B365D', '#7089AC', '#CED9E5'],
  orange: ['#A85F02', '#BF834B', '#D9B48B', '#F0DFC6'],
  red: ['#622128', '#9E2A2B', '#DDA69D', '#F0DDD7'],
  green: ['#22372B', '#476D3B', '#A3B2A4', '#E0E7D9'],
};

/** Light theme properties */
export const lightTheme: Theme = createTheme({
  typography: {
    fontFamily: 'Volvo Novum, Arial, sans-serif',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#bc9e79',
      light: '#eed3a1',
      dark: '#aa7542',
      contrastText: '#4b1b07',
    },
    secondary: {
      main: '#beac94',
      light: '#f9e5d3',
      dark: '#b0926f',
      contrastText: '#4b1b07',
    },
    background: {
      default: '#FDFDFD',
      paper: '#f9f9f9',
    },
    text: {
      primary: '#4b1b07',
      secondary: '#6d4f3c',
    },
  },
});

/** Dark theme properties */
export const darkTheme: Theme = createTheme({
  typography: {
    fontFamily: 'Volvo Novum, Arial, sans-serif',
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#beac94',
      light: '#eed3a1',
      dark: '#aa7542',
      contrastText: '#1b1b1b', // Dark background for high contrast
    },
    secondary: {
      main: '#bc9e79',
      light: '#f9e5d3',
      dark: '#b0926f',
      contrastText: '#1b1b1b',
    },
    background: {
      default: '#1b1b1b',
      paper: '#2c2c2c',
    },
    text: {
      primary: '#f9e5d3',
      secondary: '#beac94',
    },
  },
});
